var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77 3.32L6.438 2.155c-.28-.1-.586-.1-.866-.007l-2.66.894c-.54.186-.907.693-.907 1.266v7.9c0 .94.94 1.58 1.813 1.24l1.954-.76a.644.644 0 01.46-.006l3.333 1.166c.28.1.587.1.867.007l2.66-.893c.54-.18.906-.694.906-1.267v-7.9c0-.94-.94-1.58-1.813-1.24l-1.953.76a.681.681 0 01-.46.007zm.234 9.274l-4-1.407v-7.78l4 1.407v7.78z",
    fill: "#26BAAE"
  })));
}
export default SvgViewMap;